module.exports = __webpack_public_path__ + "img/Legal.5164ccaa.svg";